/**
 * 
 * 中央事件总线bus，可以作为一个简单的组件传递数据，用于解决跨级和兄弟组件通信问题
 */
const install = (Vue) => {
  const Bus = new Vue({
    methods: {
      emit(event, ...args) {
        this.$emit(event, ...args)
      },
      on(event, callback) {
        this.$on(event, callback)
      },
      off(event, callback) {
        this.$off(event, callback)
      }
    }
  })

  Vue.prototype.$bus = Bus
}

export default install